<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        :badge="totalNotification"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">Notificações</h4>
        <b-badge pill variant="light-primary">
          {{ totalNotification }}
          {{
            totalNotification > 1
              ? 'novas notificações'
              : totalNotification == 1
                ? 'nova notificação'
                : totalNotification == 0
                  ? 'notificações'
                  : ''
          }}
        </b-badge>
        <b-link class="nav-link" @click="startNotificacoesLoop">
          <feather-icon icon="SearchIcon" size="21" />
        </b-link>
      </div>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <!-- Account Notification -->
      <b-link v-for="item in notificacoes" :key="item.title">
        <b-media>
          <h6 class="font-weight-bolder media-heading">
            {{ item.title }}
          </h6>
          <small class="font-weight-bolde media-heading">{{ item.text }}</small>
        </b-media>
      </b-link>
    </vue-perfect-scrollbar>

    <!-- Cart Footer -->
    <li class="dropdown-menu-footer">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        block
        @click="deleteNotification"
      >
        Limpar as notificações
      </b-button>
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
} from 'bootstrap-vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Ripple from 'vue-ripple-directive';
import useJwt from '@/auth/jwt/useJwt';
import { mapGetters } from 'vuex';

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  computed: {
    ...mapGetters({
      userData: 'user/userData',
    }),
  },
  data() {
    return {
      notificacoes: [],
      totalNotification: null,
    };
  },
  mounted() {
    this.startNotificacoesLoop();
  },
  methods: {
    startNotificacoesLoop() {
      // Executa a busca inicialmente
      this.carregarGrid();

      // Inicia o loop a cada período de tempo
      setInterval(this.carregarGrid, 30000); // Verifica a cada 30 segundos (30000 milissegundos)
    },
    carregarGrid() {
      if (this.userData.id) {
        useJwt
          .post(`/notificacoes/buscarNotificacoes/${this.userData.id}`, {
            institutoId: this.userData.institutoSelecionado,
          })
          .then(response => {
            this.notificacoes = response.data;
            this.totalNotification = response.data.length;
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    deleteNotification() {
      useJwt
        .delete(`notificacoes/deleteNotificacoes`, this.userData.id)
        .then(response => {
          this.carregarGrid();
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
  setup() {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    return {
      perfectScrollbarSettings,
    };
  },
};
</script>

<style></style>
